export default __webpack_public_path__ + "static/media/header.f9e2b041.png";